import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import s from "./Spin.module.scss";

const Spin = ({ type, hover }) => {
  return (
    <div
      className={[s.spinning, type === "search" ? s.searching : ""].join(" ")}
      {...(hover && { style: { zIndex: "1000" } })}
    >
      <CircularProgress />
    </div>
  );
};

export default Spin;
